/** Versão do produto (sidebar) e fallback para RUM/Logs quando `VITE_APP_VERSION` não está definido. */
export const APP_SYSTEM_VERSION = '4.5.6'
